import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Scissors, Lock, Eye, EyeOff, AlertCircle } from 'lucide-react';
import './AdminLogin.css';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post('/api/admin/login', { password });
      sessionStorage.setItem('admin_password', password);
      navigate('/admin/dashboard');
    } catch {
      setError('Senha incorreta. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <Scissors size={28} strokeWidth={1.5} />
          <span>Patricia Pourroy <em>Studio</em></span>
        </div>
        <div className="admin-login-icon">
          <Lock size={32} strokeWidth={1.5} />
        </div>
        <h1>Área Administrativa</h1>
        <p>Acesso restrito. Digite a senha de administrador.</p>

        <form onSubmit={handleLogin} className="admin-login-form">
          <div className="admin-input-wrap">
            <input
              type={show ? 'text' : 'password'}
              placeholder="Senha de administrador"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button type="button" className="toggle-pw" onClick={() => setShow(s => !s)}>
              {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {error && (
            <div className="admin-login-error">
              <AlertCircle size={15} /> {error}
            </div>
          )}
          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
